'use client';

import clsx from 'clsx';
import { Grid2x2, List } from '@/components/ui/lucide-memo';

export type InventoryVisualMode = 'table' | 'grid';

interface ViewModeGraphicToggleProps {
  mode: InventoryVisualMode;
  onModeChange: (mode: InventoryVisualMode) => void;
  className?: string;
}

export function ViewModeGraphicToggle({
  mode,
  onModeChange,
  className,
}: ViewModeGraphicToggleProps) {
  const isGrid = mode === 'grid';
  const toggleMode = () => onModeChange(isGrid ? 'table' : 'grid');

  return (
    <button
      type="button"
      onClick={toggleMode}
      aria-label={isGrid ? 'Switch to table view' : 'Switch to grid view'}
      aria-pressed={isGrid}
      className={clsx(
        // ChatGPT's grid / list pair (owner, 2026-09-28): two round slots, the active one lit.
        'group relative inline-flex h-9 w-[72px] items-center rounded-full',
        className
      )}
    >
      <span
        className={clsx(
          'pointer-events-none absolute inset-y-0 left-0 w-1/2 rounded-full bg-white/[0.08] transition-transform duration-250 ease-out',
          isGrid ? 'translate-x-full' : 'translate-x-0'
        )}
      />

      <span className="relative z-10 grid h-full w-full grid-cols-2 place-items-center">
        <List
          size={16}
          strokeWidth={2.2}
          className={clsx('transition-colors duration-200', !isGrid ? 'text-white' : 'text-white/50')}
        />
        <Grid2x2
          size={16}
          strokeWidth={2.2}
          className={clsx('transition-colors duration-200', isGrid ? 'text-white' : 'text-white/50')}
        />
      </span>
    </button>
  );
}
